import React from 'react';
import ToggleField from '../../Common/ToggleField';
import { IGlobalStorefrontSettings, IStorefrontSettings } from '../../../models/Storefront';
import FulfillmentVendorTable from './FulfillmentVendorTable';
import { DefaultButton } from '@fluentui/react';

interface IFullfullmentFormProps {
    globalSettings: IGlobalStorefrontSettings;
    onGlobalSettingsChange: (updatedSettings: IGlobalStorefrontSettings) => void;
}

const FulfillmentForm: React.FC<IFullfullmentFormProps> = (props) => {

    return (
        <div>
            <h2>Fulfillment</h2>
            {/* Form fields and logic will go here */}
            <ToggleField
                label="Enable Fulfillment"
                inline
                toolTip={'Enable automatic procurement item creation on completion of a storefront order'}
                checked={props.globalSettings.procurement?.enableProcurementIntegration}
                onChange={(e, checked) => {
                    props.onGlobalSettingsChange({
                        ...props.globalSettings,
                        procurement: {
                            ...props.globalSettings.procurement,
                            enableProcurementIntegration: !!checked
                        }
                    });
                }}
                />
            <ToggleField
                label="Enable Procurement Item Creation"
                inline
                disabled={!props.globalSettings.procurement?.enableProcurementIntegration}
                toolTip={'Automatically create procurement items for orders placed in the storefront'}
                checked={props.globalSettings.procurement?.enableProcurementItemCreation}
                onChange={(e, checked) => {
                    props.onGlobalSettingsChange({
                        ...props.globalSettings,
                        procurement: {
                            ...props.globalSettings.procurement,
                            enableProcurementItemCreation: !!checked
                        }
                    });
                }}
                />
            <FulfillmentVendorTable
                settings={props.globalSettings.procurement?.vendors}
                onChange={(updatedSettings) => {
                    props.onGlobalSettingsChange({
                        ...props.globalSettings,
                        procurement: {
                            ...props.globalSettings.procurement,
                            vendors: updatedSettings
                        }
                    });
                }}
                disabled={!props.globalSettings.procurement?.enableProcurementIntegration || !props.globalSettings.procurement?.enableProcurementItemCreation}
            />
        </div>
    );
}

export default FulfillmentForm;